import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mdfcwdnw57: FaireBrandEntity = {
  token: "b_mdfcwdnw57",
  type: "brand",
  name: "Red Clover USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/4e79cb07aa77750ea255d8fea8323f59b2ca29cdd1e80f18e43df0d98b681ed6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cacc925a3e7a9201ad6b450a5ba9e9662ddd51311d9a01660a831dfd36a274df.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4e79cb07aa77750ea255d8fea8323f59b2ca29cdd1e80f18e43df0d98b681ed6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cacc925a3e7a9201ad6b450a5ba9e9662ddd51311d9a01660a831dfd36a274df.png",
  location: "Savannah, GA, USA",
  minimumOrderDollars: 166,
  rating: 3,
  reviewCount: 1,
  isInsider: true,
  description:
    "At Red Clover USA, we believe that fashion is the way for every woman to express her individual style. Since our founding in 2021, we have been dedicated to providing fashionable and feminine clothing to the modern woman. Whether it's professional attire for the office or casual outfits for the weekend, Red Clover USA has something for you.\n\nRed Clover USA was founded by a fashion-loving woman who traveled the world and discovered the unique styles of clothing in various cultures. These experiences inspired her to create a brand that could integrate global fashion elements into every piece.\n\nOur products are made from carefully selected high-quality materials, and every detail reflects our unwavering commitment to quality. Red Clover USA is committed to sustainable fashion; we use eco-friendly materials and ensure that our production processes respect human and labor rights.\n\nRed Clover USA is more than just a brand; we are a community empowering women. In the future, we plan to expand our product line to include more eco-friendly materials and host a series of workshops to enhance women's understanding of their self-worth and fashion.\n\nWe invite you to explore the world of Red Clover USA, choose the outfits that make you feel the most beautiful and confident.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.276Z",
    importedBy: "entity-db-cli",
  },
};
